import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import Boxoutline from "../../../../../../media/images/icons/outline-box";
import StarSpeed from "../../../../../../media/images/icons/star-speed";
import BigCarSpeed from "../../../../../../media/images/icons/bigcar-speed";
import DolorGreen from "../../../../../../media/images/icons/dolor-green";
import BigCarIcon from "../../../../../../media/images/icons/bigCar";
import BigCarIcon2 from "../../../../../../media/images/icons/big-car-2";
import ArrowStepLeft from "../../../../../../media/images/icons/arrow-steps-register";
import LocationFill from "../../../../../../media/images/icons/location-fill";
import FerightDetails from "./Details";

export default function FreightCard() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
        display: "flex",
        border: "1px solid gray",
        borderRadius: "16px",
        flexDirection: "column",
        padding: "8px",
        backgroundColor: "background.default",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "4px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "info.light",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "6px",
            borderRadius: "8px",
          }}
        >
          <Boxoutline color={theme.palette.textColor.main} />
        </Box>

        <Box
          sx={{
            flex: "1",
            // border: "1px solid gray",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <Typography
              sx={{
                fontWeight: "600",
              }}
            >
              کنستانتره سنگ آهن فلان کنستانتره سنگ آهن فلان
            </Typography>
            <Box
              sx={{
                // border: "1px solid gray",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "secondary.light",
                  padding: "4px",
                  borderRadius: "6px",
                }}
              >
                <StarSpeed size={20} color={theme.palette.secondary.main} />

                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "secondary.main",
                  }}
                >
                  جدید
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "primary.light",
                  padding: "4px",
                  borderRadius: "6px",
                }}
              >
                <BigCarSpeed size={20} color={theme.palette.primary.main} />

                <Typography
                  sx={{
                    fontSize: "12px",
                    color: "primary.main",
                  }}
                >
                  5222
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "primary.light",
                padding: "4px",
                borderRadius: "8px",
                gap: "4px",
              }}
            >
              <BigCarIcon2 color={theme.palette.primary.main} />
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "primary.main",
                }}
              >
                تریلر کفی - تریلر بغلدار معمولی
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "info.light",
                padding: "4px",
                borderRadius: "6px",
              }}
            >
              <DolorGreen color={theme.palette.success.main} />
              <Typography
                sx={{
                  color: "success.main",
                }}
              >
                80,000,000 ریال
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "info.light",
          paddingY: "8px",
          paddingX: "4px",
          borderRadius: "8px",
          borderColor: "info.main",
          borderWidth: "1px",
          borderStyle: "solid",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <LocationFill size={18} color={theme.palette.info.main} />
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "13px",
            }}
          >
            کهگیلویه و بویراحمد، ایلام{" "}
          </Typography>
        </Box>
        <ArrowStepLeft color={theme.palette.textColor.main} />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <LocationFill size={18} color={theme.palette.info.main} />
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "13px",
            }}
          >
            خراسان‌رضوی،خواف{" "}
          </Typography>
        </Box>
      </Box>
      <FerightDetails />
    </Box>
  );
}
